module.exports = __webpack_public_path__ + "static/media/north_melbourne.4df8438.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/north_melbourne.mp3
// module id = VEGS
// module chunks = 0